"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateOverride = exports.shouldOverride = void 0;
var OverrideEvaluation_1 = require("./OverrideEvaluation");
var shouldOverride = function (overriddenBehaviors, behaviorName) {
    return (0, OverrideEvaluation_1.shouldOverrideBmContainsBehavior)(overriddenBehaviors, behaviorName);
};
exports.shouldOverride = shouldOverride;
var evaluateOverride = function (overriddenBehaviors, behaviorName) { return (0, OverrideEvaluation_1.evaluate)(overriddenBehaviors, behaviorName); };
exports.evaluateOverride = evaluateOverride;
